import { motion } from "framer-motion";
import { useContent } from "@/lib/useContent";

export default function ManifestoIntro() {
  const { content } = useContent();
  const lines = content.manifestoIntro || [];

  return (
    <section
      id="manifest"
      data-testid="manifest-intro"
      className="relative border-t border-[#2C2C2C] bg-[#080808]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#C67022] mb-4">
            00 / Manifest
          </div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
            Read in order &mdash; or don&apos;t.
          </div>
        </div>
        <div className="col-span-12 md:col-span-9">
          {lines.map((line, i) => (
            <div key={i} className="reveal-mask block">
              <motion.div
                initial={{ y: "110%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.1, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05] py-1"
              >
                {i === 1 && line.includes("hands") ? (
                  <>
                    Four things he does with{" "}
                    <em className="italic text-[#C67022]">his hands.</em>
                  </>
                ) : (
                  line
                )}
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
